import React from "react";
import {
  QueryDriverGPSData,
  SubscribeDriverGPSData,
} from "../../../utils/graphql/hooks/driverGPSHooks";

export default function DriverGPSDataManager() {
  QueryDriverGPSData();
  SubscribeDriverGPSData();
  return <></>;
}
